const intersection = require('lodash/intersection');
const difference = require('lodash/difference');
const remove = require('lodash/remove');
const { parseUrlValue, setUrlValue } = require('./url-helpers.js');

export default() => ({
	selected_topics: [],
	selected_subtopics: [],
	topics_with_subtopics: [],
	topics_with_subtopics_data: [],
	available_topics_and_subtopics: [],
	topic_changing: false,
	ready: false,
	popping: false,
	init() {
		this.parseUrl();
		// this.$nextTick( () => queueMicrotask( () => this.parseUrl() ) );
		this.setupWatches();
	},
	parseUrl() {
		this.parseTopicsInUrl();
		this.parseSubtopicsInUrl();

		this.$nextTick(
			() => queueMicrotask(
				() => this.ready = true,
			)
		);
	},
	parseTopicsInUrl() {
		const topics = parseUrlValue('topic');
		if ( topics ) {
			this.selected_topics = topics;
			this.$nextTick( () => this.$dispatch('filter', { field: 'topic', topics }) );
		}
	},
	parseSubtopicsInUrl() {
		const subtopics = parseUrlValue('subtopic');
		if ( subtopics ) {
			this.selected_subtopics = subtopics;
			this.$nextTick( () => this.$dispatch('filter', { field: 'subtopic', subtopics }) );
		}
	},
	clearFilters() {
		this.selected_topics = [];
		this.selected_subtopics = [];
	},
	markUnavailableTopics() {
		this.available_topics_and_subtopics = this.$event.detail;
	},
	popstate() {
		const state = this.$event.state;
		this.popping = true;
		if ( state === null ) {
			this.selected_topics = [];
			this.selected_subtopics = [];
		} else {
			if ( state.subtopic ) {
				this.selected_subtopics = state.subtopic;
			} else {
				this.selected_subtopics = [];
			}

			if ( state.topic ) {
				this.selected_topics = state.topic;
			} else {
				this.selected_topics = [];
			}
		}
		this.$nextTick( () => this.popping = false );
	},
	setupWatches() {
		this.$watch(
			'selected_topics',
			(value, old_value) => {
				if (!this.ready) { return; }

				let other_pairs = [];

				if ( old_value.length > value.length ) {
					let deselected_value = difference(old_value, value);
					if ( deselected_value.length === 1 ) { deselected_value = deselected_value[0]; }
					if ( this.topics_with_subtopics_data[deselected_value] ) {
						const subtopics = this.topics_with_subtopics_data[deselected_value];
						this.topic_changing = true;
						this.$nextTick( () => this.topic_changing = false );
						remove(this.selected_subtopics, _ => subtopics.includes(_));
						other_pairs = [ 'subtopic', this.selected_subtopics ];
					}
				}
				if ( !this.popping ) {
					setUrlValue('topic', value, other_pairs );
				}
				this.$dispatch('filter', { field: 'topic', topics: value });
			}
		);
		this.$watch(
			'selected_subtopics',
			value => {
				if ( !this.ready ) { return; }

				if (
					!this.topic_changing
					&& !this.popping
				) {
					setUrlValue('subtopic', value);
				}
				this.$dispatch('filter', { field: 'subtopic', subtopics: value });
			}
		);
		this.topics_with_subtopics_data = JSON.parse( this.$refs.data.textContent );
		this.topics_with_subtopics = Object.keys(this.topics_with_subtopics_data);
	},
	get show_subtopics() {
		return intersection(this.selected_topics, this.topics_with_subtopics).length > 0;
	}
});
